import { API_ROOT } from '../../constants'
import api from '../../utils/api'

/** @todo: ability to update full site from 1 v2 endpoint, remain : uploadValues */
export const editSite = (domain, formData, config) =>
  api.post(`${API_ROOT}/v2/pro/site/update?domain=${domain}`, formData, config)

export const getSiteFiles = (formData, config) => api.get(`${API_ROOT}/v2/pro/site`, formData, config)
